import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: '[app-content]',
  imports: [CommonModule],
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
})
export class ContentComponent {
  constructor() {}
}
